const kdsPaths = {
  KDS: "",
  KDS_ID: (id) => `${id}`,
  KDS_MAPPINGS: (id) => `${id}/mappings`,
};

export default kdsPaths;

